import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import NormaRecordsByYear from './NormaVista';

const container = document.getElementById('id-norma-vista');
if (container) {
  const root = createRoot(container, {
    
  });
  root.render(
    <React.StrictMode>
      <div id="react-plugin-root">
        <NormaRecordsByYear />
      </div>
    </React.StrictMode>
  );
} else {
  console.error('Error: El contenedor raíz para la aplicación React no fue encontrado.');
}